// ordering rules for the support Ticket Board (support_ticket_board.vue),
// kept out of the component so they can be unit tested on their own.
//
// a lane's order is the ticket's queue_rank, written by the board's
// drag-to-rank (fleet-int-api rank_support_tickets). tickets nobody has
// ranked yet sort below the ranked ones, loudest first.

// the default order of a lane nobody has ranked: the loudest first. the
// list's own sort ranks (support_ticket_list.vue), so the two agree.
const URGENCY_RANK = { emergency: 4, high: 3, medium: 2, low: 1 }
const PRIORITY_RANK = { urgent: 5, minor: 4, question: 3, enhancement: 2, feature: 1 }

// the ticket's stored rank, or null when it has never been ranked. dynamo
// hands ranks back as Decimal-turned-strings on some paths, so coerce.
export function rankOf(t) {
  if (t.queue_rank === null || t.queue_rank === undefined || t.queue_rank === '') return null
  const n = Number(t.queue_rank)
  return Number.isFinite(n) ? n : null
}

// open lanes: ranked cards first in rank order, then the unranked by
// urgency, then type, then oldest first (a ticket nobody has touched in a
// month outranks this morning's). ids break ties so the order is stable.
export function openSort(a, b) {
  const ra = rankOf(a)
  const rb = rankOf(b)
  if (ra !== null && rb !== null) return ra - rb || Number(a.id) - Number(b.id)
  if (ra !== null) return -1
  if (rb !== null) return 1
  return (URGENCY_RANK[b.urgency] || 1) - (URGENCY_RANK[a.urgency] || 1)
    || (PRIORITY_RANK[b.priority] || 0) - (PRIORITY_RANK[a.priority] || 0)
    || String(a.created_at || '').localeCompare(String(b.created_at || ''))
    || Number(a.id) - Number(b.id)
}
export function closedSort(a, b) {
  return String(b.updated_at || b.created_at || '').localeCompare(String(a.updated_at || a.created_at || ''))
    || Number(b.id) - Number(a.id)
}

// the lane the viewer reordered may be a FILTERED view of the lane on the
// server: a search or a scope chip can hide cards that are still in that
// status. ranking only the visible cards 1..n would clobber the hidden
// ones' places, so the new visible order is merged back into the full lane
// -- each hidden card keeps its spot right after the visible card it used
// to follow (or the top of the lane if it led). when nothing is hidden this
// is just the visible order.
export function mergeLaneOrder(fullOld, visibleNew, keyOf) {
  const visibleKeys = new Set(visibleNew.map(keyOf))
  const leading = []
  const following = new Map()
  let lastVisible = null
  fullOld.forEach(t => {
    const k = keyOf(t)
    if (visibleKeys.has(k)) {
      lastVisible = k
      return
    }
    if (lastVisible === null) {
      leading.push(t)
    } else {
      if (!following.has(lastVisible)) following.set(lastVisible, [])
      following.get(lastVisible).push(t)
    }
  })
  const merged = [...leading]
  visibleNew.forEach(t => {
    merged.push(t)
    const tail = following.get(keyOf(t))
    if (tail) merged.push(...tail)
  })
  return merged
}
